import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson8: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson7"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Exchanges Intro
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson9"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[9.63rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>What is a Cryptocurrency Exchange?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Cryptocurrency exchanges are online platforms used to buy and
                  sell cryptocurrency. These platforms serve as intermediaries
                  between the buyer and seller, allowing their users to trade
                  cryptocurrencies using coins or fiat money (USD/EURO/etc).
                  There are several exchanges. The exchange you want to use is
                  entirely up to you. Just remember that each exchange has
                  different trading fees, so this is something you want to pay
                  attention to when picking an exchange. Everyone has their own
                  preference.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Many crypto investors choose to use cryptocurrency exchanges
                  due to their relatively low trading fees. However, keep in
                  mind that some platforms might not be beginner-friendly,
                  tending to overwhelm users, particularly those who are not
                  familiar with trading crypto.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  It's very important to understand the differences between each
                  exchange platform to find the one that works best for you as a
                  beginner or even an experienced trader.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[30.53rem] h-[19.94rem] object-cover"
            alt=""
            src="/i31@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.81rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>How to start?</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <b>
              <span>
                <span>&nbsp;</span>
              </span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>
                <span>Depositing money into your account</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>You can put money into your account in two ways.</span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>By buying crypto with fiat money.</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  By depositing crypto from another crypto wallet or exchange.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Buying crypto with fiat money</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Login to your account and head to the "Buy Crypto" page.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Select the fiat currency, enter the amount, and choose the
                  crypto you want to purchase.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Select a third-party service provider and proceed with
                  payment.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Crypto deposit from another crypto wallet or exchange</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Login to your account and head to the "Assets" page.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Click on "Deposit", select the asset and chain you wish to
                  deposit.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Click on "Copy Address" to copy the deposit address.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Go to your other crypto wallet or exchange.</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Click on "Withdraw", paste the crypto address, make sure that
                  the chain is the same, and click on "Send".
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Withdrawing money from your account</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                You can withdraw money from your Bitget account by first sending
                it to another wallet or exchange and then to your bank or credit
                card company.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Login to your account and head to the "Assets" page.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Click on "Withdraw", select the asset and chain you wish to
                  deposit.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Enter the wallet address of the platform you're withdrawing
                  from to deposit into.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Select the asset and network you would like to withdraw and
                  enter the withdrawal amount.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Click on "Submit" and complete the withdrawal verification
                  procedure.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Start trading</span>
            </b>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans">
              <span className="text-gainsboro-100">
                As on almost every exchange, you can trade in several ways.
                Three different trade ways will be explained here. It's about
                spot trading, margin trading, futures trading, and copy trading.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans">
              <span className="text-orangered">&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b className="text-[1.81rem] font-dm-sans">
              <span className="text-white">Spot Trading</span>
            </b>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <b className="text-[1.81rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <span className="text-[1.56rem] font-dm-sans">
                Spot trading is the act of buying and selling an asset at the
                current market price for instant delivery, i.e. the immediate
                transfer of asset ownership. In general, traders utilize spot
                trading to yield profits from daily market movements through a
                combination of several small transactions.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <span className="text-[1.56rem] font-dm-sans">&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b className="text-[1.81rem] font-dm-sans">
              <span className="text-white">Futures Trading</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.81rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`A futures contract is simply an agreement between two parties to transact a particular asset at a specific future time, at a negotiated price. The most celebrated attribute of futures contracts lies in their standardization: futures are virtually exchange-traded, therefore have to follow the same terms and conditions of exchanges. Most traders enjoy futures trading because of the elevated liquidity, which comes with a much lower probability of default. You can ready more `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://www.notion.so/clarity-dao-trading/level-2/futures"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">here</span>
                </span>
              </span>
            </a>
            <span>
              <span>.</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b className="text-[1.81rem] font-dm-sans">
              <span className="text-white">Margin Trading</span>
            </b>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <b className="text-[1.81rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <span className="text-[1.56rem] font-dm-sans">
                Margin requirements between exchanges can be slightly different.
                After having deposited a small fraction of their equity into the
                margin accounts, traders are given the opportunity to borrow
                equity from a third party (mostly from exchanges) and
                significantly increase their buying power. Margin therefore has
                close ties with leverage trading.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <span className="text-[1.56rem] font-dm-sans">&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b className="text-[1.81rem] font-dm-sans">
              <span className="text-white">Copy Trading</span>
            </b>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <b className="text-[1.81rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <span className="text-[1.56rem] font-dm-sans">
                Copy trading refers to the trading that investors copy or follow
                other investors (commonly known as professional traders/
                experts) to have the same positions as the experts they are
                copying. For investors, copy trading is easy to operate and
                transactions can be carried out automatically and instantly.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              <span>Types of Crypto Exchanges</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                There are two types of crypto exchanges both important to
                understand before beginning your crypto trading and investing
                journey.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.81rem] text-white">
            <b>1.) Centralized Exchanges (CEX)</b>
          </p>
          <p className="m-0">
            <span>
              <span>
                - the most common type of exchange platform and uses a third
                party to help conduct transactions. Users trust this third party
                to offer them security, monitoring, and help them find trading
                partners. This concept of centralized exchanges may seem
                contradictory to some since cryptocurrencies as a whole are
                considered decentralized with no central authority.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-white">
            <span>
              <b>Advantages:</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Easy to use - Clean UI/UX (User Interface and Experience)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Breaks down barriers of entry in crypto trading - Create an
                    account, store your login information and you can almost
                    instantly begin trading
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Home to Most Popular Exchanges - Kucoin, Coinbase, Binance,
                    etc
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Leads to extremely liquid market and trading volume
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Customer Support</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Fiat Gateways (Allows usage of fiat currencies to purchase
                    crypto)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>IEOS (Initial Exchange Offerings)</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Staking</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>{`Ease of tracking taxes & statistics for trades`}</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Leverage Opportunities**-** E.G 2x your trade</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-[1.81rem]">
            <span>
              <b>2</b>
            </span>
            <b>
              <span className="text-white">
                .) Decentralized Exchanges (DEX)
              </span>
            </b>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Unlike centralized cryptocurrency exchanges, there is no
                  middleman for decentralized exchanges. Rather, they use
                  blockchain technology or distributed ledgers. This type of
                  exchange is less common, yet still popular enough to maintain
                  liquidity. Since transactions are completed via peer-to-peer
                  using smart contracts your cryptocurrencies are not held by a
                  third party.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-white">
            <span>
              <b>Advantages:</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    No organization is "in charge" of the assets - Less
                    government intervention
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>{`Transactions and trades are automated with smart contracts & decentralized applications`}</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Very Secure (No possibility of security breach if smart
                    contract is well written)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Experienced User Friendly</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Home to the popular Uniswap and Binance Dex</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0 text-orangered">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-white">
            <span>
              <b>Disadvantages:</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Harder to use UI/UX</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Slower trading speeds</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Low trading volume and liquidity</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>No Fiat Gateway</span>
              </span>
            </li>
            <li>
              <span>
                <span>Limited tokens and number of cryptocurrencies</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b className="text-[1.88rem] font-dm-sans">
                <span className="text-white">Binance</span>
              </b>
              <span>
                <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Main platform features: Low fees, comprehensive advanced
                    charting options, and over 500 cryptocurrencies available to
                    trade
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Fees: 0.015% to 0.10% purchase and trading fees, 3.5% or $10
                    whichever is higher for debit card purchases, or $15 per
                    U.S. wire transfer
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    User Size: Estimated at around 90 million users as of March
                    2023
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Cryptocurrencies supported:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Over 500 for international traders on main Binance platform
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>{`Only 60 available for U.S. investors on `}</span>
                </span>
                <a
                  className="text-[inherit]"
                  href="http://Binance.US"
                  target="_blank"
                >
                  <span>
                    <span>
                      <span className="[text-decoration:underline]">
                        Binance.US
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    {`Security features: Two factor authentication (2FA)verification, Federal Deposit Insurance Corporation (FDIC)-insured United States dollars (USD) balances for `}
                  </span>
                </span>
                <a
                  className="text-[inherit]"
                  href="http://Binance.US"
                  target="_blank"
                >
                  <span>
                    <span>
                      <span className="[text-decoration:underline]">
                        Binance.US
                      </span>
                    </span>
                  </span>
                </a>
                <span>
                  <span>
                    , device management, address whitelisting, cold storage
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Maximum trading amount: Limits differ based on the type of
                    cryptocurrency purchased
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Types of transactions supported: Limit order, market order,
                    stop-limit order, trailing stop order, post only order,
                    peer-to-peer trading, margin trading, one-cancels-the-other
                    order, and more
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Overall Pros:</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Over 500 cryptocurrencies for trade</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>One of the cheapest platforms to use</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Massive selection of transaction types</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Overall Cons:</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    U.S. customers can’t use the main Binance platform, and the
                    Binance. US exchange is very limited
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Connecticut, Hawaii, Idaho, Louisiana, New York, Texas and
                    Vermont cannot have accounts
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    It can be overwhelming, even for experienced users
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>No built-in digital wallet</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Has some regulatory trouble in several countries and is
                    under investigation in U.S.
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <a
                className="text-[inherit]"
                href="https://accounts.binance.com/register?ref=287149938"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Binance | SIGN UP HERE:
                      https://accounts.binance.com/register?ref=287149938
                    </span>
                  </span>
                </span>
              </a>
            </p>
          </div>
          <img
            className="relative w-[30.53rem] h-[19.94rem] object-cover"
            alt=""
            src="/i32@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b className="text-[1.88rem] font-dm-sans">
                <span className="text-white">BingX</span>
              </b>
            </p>
            <p className="m-0">
              <span>
                <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Details:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Main platform features: Low fees, comprehensive advanced
                    charting options, and over 500 cryptocurrencies available to
                    trade
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Fees: 0.045% trading fees</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    User Size: Estimated at around 5 million users as of March
                    2023
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Cryptocurrencies supported:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Over 500 for international traders on main Binance platform
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>{`Only 60 available for U.S. investors on `}</span>
                </span>
                <a
                  className="text-[inherit]"
                  href="http://Binance.US"
                  target="_blank"
                >
                  <span>
                    <span>
                      <span className="[text-decoration:underline]">
                        Binance.US
                      </span>
                    </span>
                  </span>
                </a>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Security features: Two factor authentication
                    (2FA)verification
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Maximum trading amount: Limits differ based on the type of
                    cryptocurrency purchased
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Types of transactions supported: Limit order, market order,
                    stop-limit order, trailing stop order, post only order,
                    peer-to-peer trading, margin trading, one-cancels-the-other
                    order, and more
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Pros:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Over 500 cryptocurrencies for trade</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Offers Copy Trading</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Massive selection of transaction types</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Cons:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Canada can’t use the main BingX platform</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    It can be overwhelming, even for experienced users
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <a
                className="text-[inherit]"
                href="https://bingx.com/invite/ZCK3LQ"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      BingX | SIGN UP HERE:
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>{` `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://bingx.com/invite/ZCK3LQ"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      https://bingx.com/invite/ZCK3LQ
                    </span>
                  </span>
                </span>
              </a>
            </p>
          </div>
          <img
            className="relative w-[30.53rem] h-[19.94rem] object-cover"
            alt=""
            src="/i33@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b className="text-[1.88rem] font-dm-sans">
                <span className="text-white">MEXC Global</span>
              </b>
            </p>
            <p className="m-0">
              <span>
                <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Details:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Main platform features: Low fees, comprehensive advanced
                    charting options, and over 500 cryptocurrencies available to
                    trade
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Fees: 0.02% trading fees</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    User Size: Estimated at around 7 million users as of March
                    2023
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Cryptocurrencies supported:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Over 500 for international traders on main MEXC platform
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Security features: Two factor authentication
                    (2FA)verification
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Maximum trading amount: Limits differ based on the type of
                    cryptocurrency purchased
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Types of transactions supported: Limit order, market order,
                    stop-limit order, trailing stop order, post only order,
                    peer-to-peer trading, margin trading, one-cancels-the-other
                    order, and more
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Pros:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Over 500 cryptocurrencies for trade</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Massive selection of transaction types</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Cons:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    It can be overwhelming, even for experienced users
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <a
                className="text-[inherit]"
                href="https://www.mexc.com/en-US/register?inviteCode=mexc-1d5cF"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      MEXC | SIGN UP HERE:
                      https://www.mexc.com/en-US/register?inviteCode=mexc-1d5cF
                    </span>
                  </span>
                </span>
              </a>
            </p>
          </div>
          <img
            className="relative w-[35.81rem] h-[16.5rem] object-cover"
            alt=""
            src="/i34@2x.png"
          />
        </div>

        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Kucoin</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Details:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Main platform features: Intuitive, experienced trader
                    platform offering advanced transactions
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Fees: The maker/taker fee starts at 0.1% and gets lower as
                    you level up. Your fees will be reduced further if you opt
                    to pay in KCS (Kucoin's native token)
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>User Size: Estimated at over 73 million users</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Cryptocurrencies supported: 380+</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Security features: micro-withdrawal wallets, industry-level
                    multilayer encryption, dynamic multifactor authentication,
                    and dedicated internal risk control departments enforcing
                    strict security standards
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Maximum trading amount: Limits vary based on your KYC
                    (identity verification)
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Types of transactions supported: Spot trading, Margin
                    trading, P2P fiat trading, Futures trading, Staking, and
                    Lending
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Pros:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Low fees - no monthly account fees and withdrawal fees are
                    on par with competitors
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Strong growing user base - claim that 1 in 4 global crypto
                    users use their service
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Wide range of coins</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Earn interest on your crypto -Earn program "Pool-X"
                    (Staking)
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Advanced trading features - leverage trading, bot support,
                    etc
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Good customer service</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Cons:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Not licensed in the U.S.</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    U.S has strict regulations on cryptocurrency exchanges
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Limited payment methods</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Allowed to buy crypto with fiat currency but through 3rd
                    party apps with steep fees
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Not optimized for new traders</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Limited educational resources and steep learning curve
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[30.53rem] h-[19.94rem] object-cover"
            alt=""
            src="/i36@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b className="text-[1.88rem] font-dm-sans">
                <span className="text-white">ByBit</span>
              </b>
            </p>
            <p className="m-0">
              <span>
                <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Details:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Main platform features: Low fees, comprehensive advanced
                    charting options, and over 500 cryptocurrencies available to
                    trade
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Fees: 0.045% trading fees</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    User Size: Estimated at around 1.6 million users as of March
                    2023
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Cryptocurrencies supported:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Over 500 for international traders on main Bybit platform
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Security features: Two factor authentication
                    (2FA)verification
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Maximum trading amount: Limits differ based on the type of
                    cryptocurrency purchased
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Types of transactions supported: Limit order, market order,
                    stop-limit order, trailing stop order, post only order,
                    peer-to-peer trading, margin trading, one-cancels-the-other
                    order, and more
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Pros:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Over 500 cryptocurrencies for trade</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Massive selection of transaction types</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Cons:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>High Fees</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <a
                className="text-[inherit]"
                href="https://partner.bybit.com/b/unitytrades"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Bybit | SIGN UP HERE:
                      https://partner.bybit.com/b/unitytrades
                    </span>
                  </span>
                </span>
              </a>
            </p>
          </div>
          <img
            className="relative w-[30.53rem] h-[19.94rem] object-cover"
            alt=""
            src="/i35@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <a
                className="text-[inherit]"
                href="https://www.coinbase.com/join/rackz_6"
                target="_blank"
              >
                <b>
                  <span className="[text-decoration:underline]">Coinbase</span>
                </b>
              </a>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Main platform features: Intuitive, beginner-friendly
                    platform offering basic transactions, a digital wallet, and
                    withdrawals to PayPal
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Fees: 0.50% per trade, 3.99% for credit card purchases,
                    1.49% for Coinbase wallet or bank account purchases, and
                    wire transfers are $10 for deposit and $25 for withdrawal
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>User Size: Estimated at over 73 million users</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Cryptocurrencies supported: 100+</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Security features: 2FA verification, insurance for hot
                    storage if Coinbase is breached, biometric fingerprint
                    logins, cold storage, FDIC-insured USD balances, AES-256
                    encryption for digital wallets
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Maximum trading amount: Limits vary based on your payment
                    method and region
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Types of transactions supported: Buy, sell, send, receive,
                    and exchange
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Pros:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Extremely user-friendly platform</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Well-known and trusted by U.S. regulators</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Variety of ways to purchase cryptocurrency</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Rewards new users for learning about cryptos</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Great for long term portfolio plays and additions</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Cons:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Expensive fees for transactions and payment methods
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Limited advanced options for expert traders</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Much fewer transaction types than other platforms</span>
                </span>
              </li>
              <li>
                <span>
                  <span>
                    Doesn't make it ideal for following signals/alerts
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[30.53rem] h-[19.94rem] object-cover"
            alt=""
            src="/i38@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <a
            className="flex-1 relative tracking-[0.02em] leading-[2rem] [text-decoration:none] text-[inherit]"
            href="https://www.kraken.com/sign-up"
            target="_blank"
          >
            <p className="m-0 text-[1.88rem]">
              <b className="[text-decoration:underline]">
                <span>Kraken</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b className="[text-decoration:underline]">&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Details:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Main platform features: Low fees, strong security
                    protections, and tons of currency options
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Fees: 0% to 0.26% per trade, 3.75% + €0.25 for credit card
                    purchases, and 0.5% plus 0.9% or 1.5% for ACH purchases
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Cryptocurrencies supported: 93</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Security features: 2FA withdrawal email confirmation,
                    air-gapped cold storage, strict surveillance, precise API
                    key permission control, SSL encryption
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Maximum deposit and withdrawal limit: $100,000 daily
                    (intermediate level members)
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Types of transactions supported: Buy, sell, send, receive,
                    exchange, futures trading, Cryptowatch, and staking
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Pros:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Secure and reliable</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Low fees - amongst the lowest in market</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>High deposit and withdrawal limits</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Accepts various fiat currencies</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Cons:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Many options not available to U.S. users</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Limited funding options</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>No mobile app access</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Isn't available in New York or Washington</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Long verification times</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Minor learning curve</span>
                </span>
              </li>
              <li>
                <span>
                  <span>Intermediate level User Interface</span>
                </span>
              </li>
            </ul>
          </a>
          <img
            className="relative w-[36.31rem] h-[19.94rem] object-cover"
            alt=""
            src="/i39@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <a
                className="text-[inherit]"
                href="https://www.gemini.com/share/x8zdp8ysx"
                target="_blank"
              >
                <b className="[text-decoration:underline]">
                  <span>Gemini</span>
                </b>
              </a>
            </p>
            <p className="m-0 text-[1.88rem] text-gainsboro-100">
              <a
                className="text-[inherit]"
                href="https://www.kraken.com/sign-up"
                target="_blank"
              >
                <span>
                  <b className="[text-decoration:underline]">
                    <span>&nbsp;</span>
                  </b>
                </span>
              </a>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Details:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Main platform features: Beginner-friendly and secure
                    interface, multiple buying and selling options, and ability
                    to earn interest on stored crypto
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Fees: A fixed fee for trades under $200 or 1.49% for trades
                    over $200, 3.49% debit or credit card purchase
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Cryptocurrencies supported: 63</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Security features: Two-step verification, FDIC-insured USD
                    balances up to $250,000, Gemini Wallet digital insurance,
                    U2F security with a hardware key, and cold storage
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Types of transactions supported: Buy, sell, trade, deposit,
                    and withdraw
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Maximum transfer amount: $5,000 daily and $30,000 a month
                    for deposits and $100,000 daily for withdrawals via ACH.
                    $1,000 daily for debit card purchases.
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Pros:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>More advanced trading options for U.S users</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Spot Trading</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Hired director for derivatives (</span>
                </span>
                <a
                  className="text-[inherit]"
                  href="https://www.theblockcrypto.com/linked/122994/gemini-eyeing-launch-of-derivatives-hiring-for-new-director"
                  target="_blank"
                >
                  <span>
                    <span>
                      <span className="[text-decoration:underline]">
                        Looking to add futures soon
                      </span>
                    </span>
                  </span>
                </a>
                <span>
                  <span>)</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Intuitive application interface</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Stored cryptocurrency can earn interest with market APY %.
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Insurance available for their Gemini Wallet</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Overall Cons:</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Only available to users in 61 countries</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Higher fees than most competitors</span>
                </span>
              </li>
              <li>
                <span>
                  <span>
                    Lower amount of trading pairs supported compared to market
                    competition
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[36.31rem] h-[19.94rem] object-cover"
            alt=""
            src="/i40@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] inline-block h-[18.63rem]">
            <p className="m-0">
              <b>
                <span>Popular Decentralized Exchanges</span>
              </b>
            </p>
            <p className="m-0 text-orangered">
              <a
                className="text-[inherit]"
                href="https://www.kraken.com/sign-up"
                target="_blank"
              >
                <b>
                  <span className="[text-decoration:underline]">&nbsp;</span>
                </b>
              </a>
            </p>
            <p className="m-0">
              <b>
                <span className="text-white">Uniswap</span>
              </b>
            </p>
            <p className="m-0">
              <span className="text-gainsboro-100">
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span className="text-gainsboro-100">
                <span className="text-[1.56rem] font-dm-sans">Details:</span>
              </span>
            </p>
            <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span className="text-gainsboro-100">
                  <span className="text-[1.56rem] font-dm-sans">
                    Built on Ethereum (ETH) blockchain
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span className="text-gainsboro-100">
                  <span className="text-[1.56rem] font-dm-sans">
                    Has its own governance token (UNI)
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span className="text-gainsboro-100">
                  <span className="text-[1.56rem] font-dm-sans">
                    Non-profit driven
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span className="text-gainsboro-100">
                  <span className="text-[1.56rem] font-dm-sans">
                    Over $3 billion of crypto assets
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span className="text-gainsboro-100">
                <span className="text-[1.56rem] font-dm-sans">{` `}</span>
              </span>
            </p>
            <p className="m-0">
              <span className="text-gainsboro-100">
                <b className="text-[1.88rem] font-dm-sans">{` `}</b>
              </span>
            </p>
          </div>
          <img
            className="relative w-[36.31rem] h-[19.94rem] object-cover"
            alt=""
            src="/i41@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] inline-block h-[18.63rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Pancakeswap</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Details:</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Launched in 2020</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Built on Binance Smart Chain (fast and inexpensive comapred
                    to ETH)
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Reward for staking their native token (CAKE)</span>
                </span>
              </li>
              <li>
                <span>
                  <span>Cheaper and faster transactions than Uniswap</span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[36.31rem] h-[19.94rem] object-cover"
            alt=""
            src="/i42@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Key Takeaways</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Choosing from either the best-centralized exchange or
                decentralized exchange is going to completely depend on you and
                your level of comfortability.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you are with a decentralized exchange, a higher level of
                responsibility and time will be needed to safeguard your own
                assets!
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Centralized exchanges are the better options for any beginner
                and even experienced crypto traders. Make sure your exchange
                supports the types of transactions you are looking to conduct
                before adding funds.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>What are Exchange Fees</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Exchange fees are a type of investment fee that some mutual
                funds charge to shareholders if they transfer to another fund
                within the same group. Other fees shareholders may encounter
                include sales loads, redemption fees, purchase fees, account
                fees, 12b-1 fees, and management fees.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>How Exchange Fees Work</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Exchange fees are charged by management investment companies
                that allow investors to exchange or transfer shares from one
                mutual fund to another mutual fund managed by the company.
                Exchange fees are unique in that they only occur when an
                inter-fund transaction is requested. Mutual fund exchanges are
                discussed in a mutual fund’s prospectus along with the other
                fees an investor will pay with investment in the fund. Many
                mutual fund companies do not charge a fee for exchanging shares.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Exchanging Mutual Fund Shares</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The opportunity to exchange mutual funds is often called an
                exchange privilege. Exchange privileges can be beneficial for
                investors seeking to shift mutual fund allocations based on
                market conditions. For example, an investor in a growth equity
                fund during a bull market may seek to exchange shares for a bond
                fund if their outlook becomes more bearish. Additionally,
                do-it-yourself investors may be able to automate fund exchanges
                at a specified target date in order to shift higher risk
                allocations into more conservative funds.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Mutual fund exchanges are generally a common practice that is
                allowed by most mutual fund companies with multiple fund
                offerings. However, the exchange transactions can require due
                diligence in order to complete. Most exchanges must be done
                through a special request or with a registered representative.
                Some platforms will allow the investor to make fund exchanges
                easily online. Each trading platform and mutual fund account has
                its own way of handling mutual fund exchanges.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Paying Exchange Fees</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Fund exchange details can be found in a mutual fund’s
                prospectus. Often an exchange privilege will have no cost.
                However, exchanging shares may trigger taxation if a capital
                gain occurs.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Tax requirements are most common in a fund-to-fund transfer, but
                converting share classes in the same fund is usually considered
                a non-taxable event
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson9">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson8;
